import { render, staticRenderFns } from "./TurnaroundUpsellTable.vue?vue&type=template&id=5a0216ad&scoped=true&"
import script from "./TurnaroundUpsellTable.vue?vue&type=script&lang=js&"
export * from "./TurnaroundUpsellTable.vue?vue&type=script&lang=js&"
import style0 from "./TurnaroundUpsellTable.vue?vue&type=style&index=0&id=5a0216ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0216ad",
  null
  
)

export default component.exports